import { Progress } from "antd";

import { DefaultCss } from "./ProgressBar.styles";

type CustomProgressBarProps = {
  percent: number;
  maxWidth?: number;
};

export function ProgressBar({
  percent,
  maxWidth = 262,
}: CustomProgressBarProps): any {
  return (
    <Progress
      style={{ width: "100%", maxWidth }}
      percent={percent}
      strokeColor="var(--colors-surveys-progress-bar-stroke-color)"
      trailColor="var(--colors-surveys-progress-bar-trail-color)"
      className={DefaultCss()}
      strokeLinecap="round"
    />
  );
}
